module.exports = __webpack_public_path__ + "components/flag/static/square/xx-bd721ab40c55547aee108980e4f5a79b.svg";